import { Icon, IconArrowRightArcDots } from "@flixbus/honeycomb-icons-react";
import React from "react";
import * as css from "./Interconnection.scss";

type Props = {
  interconnectionStations: Array<{ name: string } | null>;
};

const Interconnection: React.FC<Props> = ({ interconnectionStations }) => {
  if (interconnectionStations.length == 0) {
    return <span id={"emptyInterconnections"}>-</span>;
  }

  return (
    <div id={"interconnections"}>
      {interconnectionStations.map((station) => {
        return (
          <div id={"interconnection"} key={station!.name} className={css.interconnectionCell}>
            <Icon InlineIcon={IconArrowRightArcDots} size={3} className={css.interconnectionIcon} />
            <span className={css.interconnectionText}>{station!.name}</span>
          </div>
        );
      })}
    </div>
  );
};

export default Interconnection;
